import React, { useEffect, useMemo, useState } from "react";
import Pagination from "../../componentes/pagination/Pagination";
import { Loading } from "../../componentes/loading/loading";
import { formatarMoedaBrasileira } from "../../utils/formatarMoedaBrasileira";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Skeleton } from 'primereact/skeleton';
import Button from "../../componentes/button/button";
import { IoSparklesSharp } from "react-icons/io5";
import ButtonDropdown from "../../componentes/button-dropdown/buttonDropdown";

export default function BPPageTabela({
  data,
  openModal,
  loading,
  service,
  onModalExcel,
  exportarPlanilha,
  marcarComoPendente,
  marcarComoRealizado,
  usuarios,
  handleUsuarios,
  fetch,
  usuario
}) {
  const [changeData, setChangeData] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [showCompartilhar, setShowCompartilhar] = useState(false);
  const [showDescompartilhar, setShowDescompartilhar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filters, setFilters] = useState({
    conta: [],
    centroCusto: [],
    filial: [],
    status: [],
    compartilhado: [],
    tipo: [],
    usuarioCompartilhado: []
  });

  useEffect(() => {
    const savedFilters = localStorage.getItem("filters");

    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);

      setFilters({
        conta: parsed.conta ?? [],
        centroCusto: parsed.centroCusto ?? [],
        filial: parsed.filial ?? [],
        status: parsed.status ?? [],
        compartilhado: parsed.compartilhado ?? [],
        tipo: parsed.tipo ?? [],
        usuarioCompartilhado: parsed.usuarioCompartilhado ?? [],
      });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("filters", JSON.stringify(filters));
  }, [filters]);


  const clearFilters = () => {
    const emptyFilters = {
      conta: [],
      centroCusto: [],
      filial: [],
      status: [],
      compartilhado: [],
      tipo: [],
      usuarioCompartilhado: []
    };
    setFilters(emptyFilters);
    localStorage.removeItem("filters"); // opcional
  };

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const filteredData = useMemo(() => {
    let filtered = data.filter((item) => {

      const matchConta =
        filters.conta.length === 0 ||
        filters.conta.includes(item.contaReduzido);

      const matchCentro =
        filters.centroCusto.length === 0 ||
        filters.centroCusto.includes((item.centroCustoCodigo ?? "").toString());

      const matchFilial =
        filters.filial.length === 0 ||
        filters.filial.includes(item.filialNome);

      const matchTipo =
        filters.tipo.length === 0 ||
        filters.tipo.includes(item.contaTipo);

      const matchUsuarioCompartilhado =
        filters.usuarioCompartilhado.length === 0 ||
        filters.usuarioCompartilhado.includes(item.responsavelNome);

      const matchStatus =
        filters.status.length === 0 ||
        (filters.status.includes("atualizado") && item.contaOrcada === true) ||
        (filters.status.includes("pendente") && item.contaOrcada === false);

      const matchCompartilhado =
        filters.compartilhado.length === 0 ||
        (filters.compartilhado.includes("true") && (item.compartilhado === true && (item.responsavelNome === usuario.nome))) ||
        (filters.compartilhado.includes("false") && item.compartilhado === false) ||
        (filters.compartilhado.includes("true_comigo") && (item.compartilhado === true && (item.responsavelNome !== usuario?.nome)));

      return matchConta && matchCentro && matchFilial && matchStatus && matchCompartilhado && matchTipo && matchUsuarioCompartilhado;
    });

    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        let valueA;
        let valueB;

        if (sortConfig.key === "saldoTotal") {
          valueA = (a.valorTotal ?? 0) - (a.valorTotalRealizadoAtual ?? 0);
          valueB = (b.valorTotal ?? 0) - (b.valorTotalRealizadoAtual ?? 0);
        } else if (sortConfig.key === "percentualRealizado") {
          const orcadoA = Number(a.valorTotal) || 0;
          const orcadoB = Number(b.valorTotal) || 0;
          valueA = orcadoA > 0 ? ((Number(a.valorTotalRealizadoAtual) || 0) / orcadoA) * 100 : 0;
          valueB = orcadoB > 0 ? ((Number(b.valorTotalRealizadoAtual) || 0) / orcadoB) * 100 : 0;
        } else {
          valueA = a[sortConfig.key];
          valueB = b[sortConfig.key];
        }

        if (typeof valueA === "string" && typeof valueB === "string") {
          return sortConfig.direction === "asc"
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }

        if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }

    return filtered;
  }, [data, filters, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  useEffect(() => {
    setChangeData(filteredData);
  }, [filteredData]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const totalOrcado = filteredData.filter(item => item.contaOrcada === true).length;
  const totalPendente = filteredData.filter(item => item.contaOrcada === false).length;
  const valorOrcado = filteredData.reduce((acc, item) => acc + (item.valorTotal || 0), 0);
  const valorRealizado = filteredData.reduce((acc, item) => acc + (item.valorTotalRealizadoAtual || 0), 0);

  function toggleSelectedRow(id) {
    setSelectedRows(prev => {
      if (prev.includes(id)) {
        return prev.filter(item => item !== id);
      } else {
        return [...prev, id];
      }
    });
  }

  function toggleSelectAll() {
    if (selectedRows.length === changeData.length) {
      // desmarcar tudo
      setSelectedRows([]);
    } else {
      // selecionar todos
      setSelectedRows(changeData.map(row => row.id));
    }
  }

  function clearCompartilhamento() {
    setShowCompartilhar(false);
    setShowDescompartilhar(false);
    setSelectedRows([]);
    setUsuarioSelecionado(null);
  }

  function compartilharComUsuario() {
    service.compartilhar(selectedRows, usuarioSelecionado)
      .then(() => {
        toast.success(`${selectedRows.length} itens compartilhados.`);
        clearCompartilhamento();
        setFilters(prev => ({ ...prev, compartilhado: [] }))
        fetch();
      })
      .catch((e) => {
        console.error(e)
      })
  }

  function descompartilhar() {
    service.descompartilhar(selectedRows)
      .then(() => {
        toast.success(`${selectedRows.length} itens descompartilhados.`);
        clearCompartilhamento();
        setFilters(prev => ({ ...prev, compartilhado: [] }))
        fetch();
      })
      .catch(() => {
        toast.error("Erro ao descompartilhar itens.");
      });
  }

  const optionsConta = useMemo(() => {
    const unique = [
      ...new Map(
        data.map(item => [
          item.contaReduzido,
          {
            label: `${item.contaReduzido} - ${item.contaDescricao}`,
            value: item.contaReduzido,
          }
        ])
      ).values()
    ];

    // Ordenar por label (alfabético)
    return unique.sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  const optionsCentro = useMemo(() => {
    const mapa = new Map();

    data.forEach(d => {
      const codigo = (d.centroCustoCodigo ?? "").toString().trim();
      const descricao = (d.centroCustoDescricao ?? "").toString().trim();

      if (!codigo) return; // pula itens sem código

      if (!mapa.has(codigo)) {
        mapa.set(codigo, {
          label: `${codigo} - ${descricao}`,
          value: codigo
        });
      }
    });

    return Array.from(mapa.values()).sort((a, b) => { return Number(a.value) - Number(b.value) });
  }, [data]);

  const optionsFilial = Array.from(
    new Map(
      data
        .sort((a, b) => a.filialNome.localeCompare(b.filialNome))
        .map(d => [d.filialNome, { label: d.filialNome, value: d.filialNome }])
    ).values()
  );

  const optionsTipo = Array.from(
    new Map(
      data
        .sort((a, b) => a.contaTipo?.localeCompare(b.contaTipo))
        .map(d => [d.contaTipo, { label: d.contaTipo, value: d.contaTipo }])
    ).values()
  );

  const optionsUsuarioCompartilhado = Array.from(
    new Map(
      data
        .filter(d => d.compartilhado === true)
        .map(d => [d.responsavelNome, { label: d.responsavelNome, value: d.responsavelNome }])
    ).values()
  );

  const items = [
    { label: 'Exportar Planilha', icon: 'fa fa-upload', command: () => exportarPlanilha(filters) },
    { label: 'Importar Planilha', icon: 'fa fa-file-excel', command: onModalExcel },
    {
      label: 'Compartilhar Contas',
      icon: 'fa fa-share-alt',
      command: () => {
        handleFilterChange("compartilhado", ["false"])
        handleUsuarios();
        setShowCompartilhar(true);
      }
    },
    {
      label: 'Remover Compartilhamento',
      icon: 'fa fa-times',
      command: () => {
        setShowDescompartilhar(true);
        handleFilterChange("compartilhado", ["true"])

      }
    },
  ];

  const MESES = [
    { key: "JANEIRO", label: "JANEIRO" },
    { key: "FEVEREIRO", label: "FEVEREIRO" },
    { key: "MARCO", label: "MARÇO" },
    { key: "ABRIL", label: "ABRIL" },
    { key: "MAIO", label: "MAIO" },
    { key: "JUNHO", label: "JUNHO" },
    { key: "JULHO", label: "JULHO" },
    { key: "AGOSTO", label: "AGOSTO" },
    { key: "SETEMBRO", label: "SETEMBRO" },
    { key: "OUTUBRO", label: "OUTUBRO" },
    { key: "NOVEMBRO", label: "NOVEMBRO" },
    { key: "DEZEMBRO", label: "DEZEMBRO" },
  ];

  const formatBRL = (v) =>
    (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const normalizarValor = (valor) => {
    if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
    if (valor == null || valor === "") return 0;

    const texto = String(valor).replace(/R\$|\s/g, "");
    const numero = texto.includes(",")
      ? Number(texto.replace(/\./g, "").replace(",", "."))
      : Number(texto);

    return Number.isFinite(numero) ? numero : 0;
  };

  const calcularPercentualRealizado = (realizado, orcado) => {
    const valorRealizado = normalizarValor(realizado);
    const valorOrcado = normalizarValor(orcado);

    // Não há limite máximo: R$ 1.200 realizados sobre R$ 1.000 orçados = 120%.
    return valorOrcado > 0 ? (valorRealizado / valorOrcado) * 100 : 0;
  };

  // coluna sticky do identificador desloca conforme existência da coluna de checkbox
  const idColLeftClass = (showCompartilhar || showDescompartilhar) ? "left-10" : "left-0";

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden pb-3">
      {/* === FILTROS === */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex flex-wrap justify-between">
          <div className="flex flex-wrap items-center">
            <div className="bg-indigo-100 p-3 rounded-lg mr-4">
              <i className="fas fa-file-invoice-dollar text-indigo-600 text-xl"></i>
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800">BP 2026</h2>
              <p className="text-gray-600">Orçamentos de Contas para BP 2026 </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3 text-right items-center text-xs">
            <Info color="gray" label="Valor Orçado" value={"R$ " + formatarMoedaBrasileira(valorOrcado)} loading={loading} />
            <Info color="blue" label="Valor Realizado 2026" value={"R$ " + formatarMoedaBrasileira(valorRealizado)} loading={loading} />
            <Info color="green" label="Contas Orçadas" value={totalOrcado} loading={loading} />
            <Info color="yellow" label="Contas Pendentes" value={totalPendente} loading={loading} />
            <Info color="indigo" label="Total de Contas" value={filteredData.length} loading={loading} />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap py-4">
        <form className="col-12 col-md-12 p-0" >
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-3 gap-4 ">
            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Conta</label>
              <MultiSelect
                value={filters.conta}
                options={optionsConta}
                onChange={(e) => handleFilterChange("conta", e.value)}
                optionLabel="label"
                optionValue="value"
                filterBy="label"
                display="chip"
                className="w-full text-xs border"
                filter
                filterPlaceholder="Pesquisar..."
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Centro de Custo</label>
              <MultiSelect
                value={filters.centroCusto}
                options={optionsCentro}
                onChange={(e) => handleFilterChange("centroCusto", e.value)}
                optionLabel="label"
                optionValue="value"
                filterBy="label"
                display="chip"
                className="w-full text-xs border"
                filter
                filterPlaceholder="Pesquisar..."
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Filial</label>
              <MultiSelect
                value={filters.filial}
                options={optionsFilial}
                onChange={(e) => handleFilterChange("filial", e.value)}
                optionLabel="label"
                display="chip"
                className="w-full text-xs border"
                filter
                filterPlaceholder="Pesquisar..."
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Tipo de Conta</label>
              <MultiSelect
                value={filters.tipo}
                options={optionsTipo}
                onChange={(e) => handleFilterChange("tipo", e.value)}
                optionLabel="label"
                display="chip"
                className="w-full text-xs border"
                filter
                filterPlaceholder="Pesquisar..."
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Status</label>
              <MultiSelect
                value={filters.status}
                options={[
                  { label: "Realizado", value: "atualizado" },
                  { label: "Pendente", value: "pendente" }
                ]}
                onChange={(e) => handleFilterChange("status", e.value)}
                display="chip"
                className="w-full text-xs border"
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div className="col-span-1">
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Compartilhamento</label>
              <MultiSelect
                value={filters.compartilhado}
                disabled={showCompartilhar || showDescompartilhar}
                options={[
                  { label: "Somente minhas Contas", value: "false" },
                  { label: "Compartilhadas por mim", value: "true" },
                  { label: "Compartilhadas Comigo", value: "true_comigo" },
                ]}
                onChange={(e) => handleFilterChange("compartilhado", e.value)}
                display="chip"
                className="w-full text-xs border"
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div>
              <label htmlFor className="block text-xs font-medium text-gray-700 mb-1">Filtro por Usuário Compartilhado</label>
              <MultiSelect
                value={filters.usuarioCompartilhado}
                options={optionsUsuarioCompartilhado}
                onChange={(e) => handleFilterChange("usuarioCompartilhado", e.value)}
                optionLabel="label"
                display="chip"
                className="w-full text-xs border"
                filter
                filterPlaceholder="Pesquisar..."
                emptyMessage="Não existe contas compartilhadas"
                itemClassName="text-[11px]"
                pt={{
                  token: {
                    className: "text-[10px] px-2 py-0"
                  },
                  tokenLabel: {
                    className: "text-[10px]"
                  },
                  checkbox: {
                    root: {
                      className: "scale-75"
                    }
                  }
                }}
              />
            </div>

            <div className="flex flex-row-reverse justify-between col-span-1 md:col-span-1 flex-wrap items-end gap-1 justify-start mt-3">
              {(!showCompartilhar && !showDescompartilhar) &&
                <>
                  {Object.values(filters).every(
                    (value) => Array.isArray(value) && value.length === 0
                  ) === false &&
                    <Button type="button"
                      label="Limpar Filtros"
                      iconLeft="fa fa-eraser"
                      onClick={clearFilters}
                      className="bg-white  flex py-2 px-2 text-xs text-dark hover:underline" />
                  }
                </>
              }

            </div>
          </div>
        </form>
      </div>

      <div className="mx-3 mb-4 flex items-center justify-between rounded-lg border border-blue-200 bg-blue-50 px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-blue-600">
            <IoSparklesSharp />

          </div>

          <div>
            <p className="text-sm font-semibold text-slate-800">
              Nova visualização disponível
            </p>
            <p className="text-xs text-slate-600">
              Alterne entre a visualização resumida e detalhada da tabela.
            </p>
          </div>
        </div>

        <div className="flex gap-2">

          <Button
            variant="blueLight"
            onClick={() => setShowDetails(!showDetails)}
            iconLeft="fa fa-asterisk"
            label={showDetails ? "Visualização Resumida" : "Visualização Detalhada"}
          >
          </Button>

          <ButtonDropdown
            disabled={showCompartilhar || showDescompartilhar}
            title="Configurações"
            variant="indigo"
            iconLeft="fa fa-cog"
            label={"Configurações"}
            items={items}
          />
        </div>
      </div>

      {showDetails ?

        <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200 text-xs">
            <thead className="bg-gray-100">
              <tr className="border-top">
                {(showCompartilhar || showDescompartilhar) && (
                  <th
                    rowSpan={1}
                    className="sticky left-0 z-20 bg-gray-100 px-3 py-3 w-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                  >
                    <input
                      type="checkbox"
                      className="w-4 h-4 cursor-pointer"
                      checked={selectedRows.length === changeData.length && changeData.length > 0}
                      onChange={toggleSelectAll}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </th>
                )}

                {/* coluna sticky: Centro de Custo + Conta */}
                <th
                  className={`sticky ${idColLeftClass} z-20 bg-gray-100 px-2 py-2 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500 min-w-[220px]`}
                >
                  <div className="flex flex-col gap-0.5 px-2">
                    <span
                      className="cursor-pointer "
                      onClick={() => handleSort("contaReduzido")}
                    >
                      CONTA {sortConfig.key === "contaReduzido" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                    </span>
                    <span
                      className="cursor-pointer normal-case font-normal text-[10px] text-gray-500"
                      onClick={() => handleSort("centroCustoCodigo")}
                    >
                      C.CUSTO {sortConfig.key === "centroCustoCodigo" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                    </span>
                  </div>
                </th>
                <th
                  className="px-2 py-2 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500 cursor-pointer"
                  onClick={() => handleSort("contaTipo")}
                >
                  Tipo Conta {sortConfig.key === "contaTipo" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th
                  className="px-2 py-2 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500 cursor-pointer"
                  onClick={() => handleSort("filialNome")}
                >
                  Filial {sortConfig.key === "filialNome" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>

                <th className="px-4 py-2 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500 cursor-pointer">
                  <div onClick={() => handleSort("valorTotalRealizadoAtual")}>
                    Totais Orçado {sortConfig.key === "valorTotalRealizadoAtual" && (sortConfig.direction === "asc" ? "↓" : "↓")}
                  </div>
                  <div onClick={() => handleSort("valorTotal")}>
                    Realizado {sortConfig.key === "valorTotal" && (sortConfig.direction === "asc" ? "↓" : "↑")}
                  </div>
                  <div onClick={() => handleSort("saldoTotal")}>
                    Saldo {sortConfig.key === "saldoTotal" && (sortConfig.direction === "asc" ? "↓" : "↑")}
                  </div>

                </th>

                {/* cabeçalho dos meses */}
                {MESES.map((mes) => (
                  <th
                    key={mes.key}
                    className="px-2 py-2 text-center text-[10px] font-bold uppercase tracking-widest text-slate-500 border-l border-gray-200"
                  >
                    {mes.label}
                  </th>
                ))}


                <th className="px-3 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Compartilhado
                </th>
                <th className="px-3 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Status
                </th>
              </tr>
              <tr className="border-top">
                {(showCompartilhar) || (showDescompartilhar) ?
                  <>
                    {(showCompartilhar || showDescompartilhar) &&
                      <th className="px-3 py-3 w-16 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer">
                        {(showCompartilhar || showDescompartilhar) ? (
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer"
                            checked={selectedRows.length === changeData.length && changeData.length > 0}
                            onChange={toggleSelectAll}
                            onClick={(e) => e.stopPropagation()} // evita triggers de sort
                          />
                        ) : (
                          <i className="">#</i>
                        )}
                      </th>
                    }
                    <th colSpan={18} >
                      <div className="py-1 flex gap-2 w-full fade-in">
                        {showCompartilhar &&
                          <div className="w-64">
                            <Dropdown
                              value={usuarioSelecionado}
                              onChange={(e) => setUsuarioSelecionado(e.target.value)}
                              options={usuarios}
                              optionValue="id"
                              optionLabel="nome"

                              filter
                              showClear
                              placeholder="Selecione o usuário"
                              emptyMessage="Nenhuma opção a exibir"
                              filterPlaceholder="Buscar..."
                              className="w-full  border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-primary focus:border-primary text-xs"
                              panelClassName="rounded-xl shadow-lg"
                            />
                          </div>
                        }
                        {showCompartilhar &&
                          <Button
                            variant="indigo"
                            label="Compartilhar"
                            disabled={!usuarioSelecionado || selectedRows.length < 1}
                            onClick={compartilharComUsuario}
                          />
                        }
                        {showDescompartilhar &&
                          <Button
                            variant="red"
                            label="Remover Acesso"
                            disabled={selectedRows.length < 1}
                            onClick={descompartilhar}
                          />
                        }
                        <Button
                          variant="white"
                          label="Cancelar"
                          onClick={() => {
                            setShowCompartilhar(false);
                            setShowDescompartilhar(false);
                            setUsuarioSelecionado(null);
                            setFilters(prev => ({ ...prev, compartilhado: [] }))
                            setSelectedRows([]);
                          }}
                        />
                      </div>
                    </th>
                  </>
                  :
                  null
                }
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan={9 + MESES.length * 3 + 3} className="text-center py-4 text-gray-500 text-xs">
                    <Loading />
                  </td>
                </tr>
              ) : changeData.length === 0 ? (
                <tr>
                  <td colSpan={9 + MESES.length * 3 + 3} className="text-center py-4 text-gray-500 text-xs">
                    Nenhum registro encontrado
                  </td>
                </tr>
              ) : (
                changeData.map((row) => {
                  const saldoTotal = (row.valorTotal ?? 0) - (row.valorTotalRealizadoAtual ?? 0);
                  return (
                    <tr key={row.id} className="highlight-row hover:brightness-95 group cursor-pointer">
                      {(showCompartilhar || showDescompartilhar) && (
                        <td className="sticky left-0 z-10 bg-white px-3 py-2 w-10 text-xs text-gray-600">
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer"
                            checked={selectedRows.includes(row.id)}
                            onChange={() => toggleSelectedRow(row.id)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>
                      )}

                      <td
                        onClick={() => openModal(row)}
                        className={`sticky ${idColLeftClass} z-10 min-w-[220px] cursor-pointer border-b border-gray-200 bg-white px-3 py-2 `}
                      >
                        <div className="text-[12px] leading-tight text-slate-700">
                          <span className="font-bold">{row.contaDescricao}</span>   ({row.contaReduzido})
                        </div>

                        <div className="mt-1 text-xs leading-tight text-slate-700">
                          {row.centroCustoDescricao}   ({row.centroCustoCodigo})
                        </div>
                      </td>

                      <td onClick={() => openModal(row)} className="bg-white px-2 py-2 text-xs">
                        <div className="text-slate-700 font-semibold">{row.grupoDescricao}</div>
                        <div className="text-slate-500">{row.contaTipo}</div>
                      </td>

                      <td onClick={() => openModal(row)} className="bg-white px-2 py-2 text-nowrap ">
                        <span className="text-blue-700 bg-blue-50 px-2 py-1 rounded-lg font-semibold text-[11px]">
                          {row.filialNome}
                        </span>
                      </td>

                      <td
                        onClick={() => openModal(row)}
                        className={`px-4 py-2 text-center text-xs border border-gray-200 cursor-pointer whitespace-nowrap transition-colors ${saldoTotal >= 0 ? "bg-green-50" : "bg-red-50"
                          }`}
                      >
                        <div className="text-blue-500 font-semibold">
                          {formatBRL(row.valorTotal)}
                        </div>

                        <div className="text-slate-500 font-semibold">
                          {formatBRL(row.valorTotalRealizadoAtual)}
                        </div>

                        <div
                          className={`font-bold ${saldoTotal >= 0 ? "text-green-700" : "text-red-700"
                            }`}
                        >
                          {formatBRL(saldoTotal)}
                        </div>
                      </td>

                      {MESES.map((mes) => {
                        const orcado = row.valoresMensais?.[mes.key] ?? 0;
                        const realizado = row.despesasMensaisAtual?.[mes.key] ?? 0;
                        const saldo = orcado - realizado;

                        const saldoPositivo = saldo >= 0;

                        return (
                          <td
                            key={mes.key}
                            onClick={() => openModal(row)}
                            className={`px-4 py-2 text-center text-xs border border-gray-100 cursor-pointer whitespace-nowrap transition-colors ${saldoPositivo ? "bg-green-50" : "bg-red-50"
                              }`}
                          >
                            <div className="text-blue-500 font-semibold">
                              {formatBRL(orcado)}
                            </div>

                            <div className="text-slate-500 font-semibold">
                              {formatBRL(realizado)}
                            </div>

                            <div
                              className={`font-semibold tracking-wider ${saldoPositivo ? "text-green-600" : "text-red-600"
                                }`}
                            >
                              {formatBRL(saldo)}
                            </div>
                          </td>
                        );
                      })}

                      <td onClick={() => openModal(row)} className="px-3 py-2 text-xs text-gray-700 cursor-pointer">
                        {row.compartilhado === true && (
                          row.usuarioCompartilhadoEmail === usuario.sub ? (
                            <span className="px-3 py-1 bg-gray-200 rounded-full text-gray-800 text-xs">{row.responsavelNomeUsuario}</span>
                          ) : (
                            <span className="px-3 py-1 bg-slate-200 rounded-full text-slate-800 text-xs">Para: {row.usuarioCompartilhado}</span>
                          )
                        )}
                      </td>

                      <td onClick={() => openModal(row)} className="px-3 py-2 text-center cursor-pointer">
                        {row.contaOrcada ? (
                          <span className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-xs whitespace-nowrap">Realizado</span>
                        ) : (
                          <span className="px-2 py-1 bg-yellow-200 text-yellow-800 rounded-full text-xs whitespace-nowrap">Pendente</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        :
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr className="border-top">
                {(showCompartilhar || showDescompartilhar) &&
                  <th className="px-3 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer">  </th>
                }
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("filialNome")}>
                  Filial {sortConfig.key === "filialNome" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="pl-2  py-3 pr-0 text-right text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("contaReduzido")}>
                  Conta {sortConfig.key === "contaReduzido" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="pr-3 pl-1 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("contaDescricao")}>
                  Descrição {sortConfig.key === "contaDescricao" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="pl-2 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("centroCustoCodigo")}>
                  C.C {sortConfig.key === "centroCustoCodigo" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="pr-3 pl-1 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("centroCustoDescricao")}>
                  Descrição {sortConfig.key === "centroCustoDescricao" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="px-2 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("contaTipo")}>
                  Tipo Conta {sortConfig.key === "contaTipo" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>
                <th className="py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Compartilhado
                </th>
                <th className="px-3 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("valorTotalRealizadoAtual")}>
                  <div className="text-[11px] font-bold normal-case text-blue-700">{formatBRL(valorRealizado)}</div>
                  Realizado 2026 {sortConfig.key === "valorTotalRealizadoAtual" && (sortConfig.direction === "asc" ? "↓" : "↓")}
                </th>
                <th className="px-2 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer" onClick={() => handleSort("valorTotal")}>
                  <div className="text-[11px] font-bold normal-case text-slate-700">{formatBRL(valorOrcado)}</div>
                  <strong> Orçado 2026 </strong> {sortConfig.key === "valorTotal" && (sortConfig.direction === "asc" ? "↓" : "↑")}
                </th>
                <th
                  className="px-1 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer"
                  onClick={() => handleSort("percentualRealizado")}
                >
                  <strong> (%) </strong> {sortConfig.key === "percentualRealizado" && (sortConfig.direction === "asc" ? "↓" : "↑")}
                </th>
                <th className="px-3 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Status</th>
              </tr>
              <tr className="border-top">
                {(showCompartilhar) || (showDescompartilhar) ?
                  <>
                    {(showCompartilhar || showDescompartilhar) &&
                      <th className="px-3 py-3 w-16 text-left text-xs font-medium text-gray-700 uppercase tracking-wider cursor-pointer">
                        {(showCompartilhar || showDescompartilhar) ? (
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer"
                            checked={selectedRows.length === changeData.length && changeData.length > 0}
                            onChange={toggleSelectAll}
                            onClick={(e) => e.stopPropagation()} // evita triggers de sort
                          />
                        ) : (
                          <i className="">#</i>
                        )}
                      </th>
                    }
                    <th colSpan={10} >
                      <div className="py-1 flex gap-2 w-full fade-in">
                        {showCompartilhar &&
                          <div className="w-64">
                            <Dropdown
                              value={usuarioSelecionado}
                              onChange={(e) => setUsuarioSelecionado(e.target.value)}
                              options={usuarios}
                              optionValue="id"
                              optionLabel="nome"

                              filter
                              showClear
                              placeholder="Selecione o usuário"
                              emptyMessage="Nenhuma opção a exibir"
                              filterPlaceholder="Buscar..."
                              className="w-full  border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-primary focus:border-primary text-xs"
                              panelClassName="rounded-xl shadow-lg"
                            />
                          </div>
                        }
                        {showCompartilhar &&
                          <Button
                            variant="indigo"
                            label="Compartilhar"
                            disabled={!usuarioSelecionado || selectedRows.length < 1}
                            onClick={compartilharComUsuario}
                          />
                        }
                        {showDescompartilhar &&
                          <Button
                            variant="red"
                            label="Remover Acesso"
                            disabled={selectedRows.length < 1}
                            onClick={descompartilhar}
                          />
                        }
                        <Button
                          variant="white"
                          label="Cancelar"
                          onClick={() => {
                            setShowCompartilhar(false);
                            setShowDescompartilhar(false);
                            setUsuarioSelecionado(null);
                            setFilters(prev => ({ ...prev, compartilhado: [] }))
                            setSelectedRows([]);
                          }}
                        />
                      </div>
                    </th>
                  </>
                  :
                  null
                }
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ?
                <tr>
                  <td colSpan={9} className="text-center py-4 text-gray-500 text-xs">
                    <Loading />
                  </td>
                </tr>
                :
                (<>{
                  changeData.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center py-4 text-gray-500 text-xs">
                        Nenhum registro encontrado
                      </td>
                    </tr>
                  ) : (
                    changeData.map((row, index) => (
                      <tr
                        key={row.id}
                        className={`highlight-row cursor-pointer 
                     `}                    >
                        {(showCompartilhar || showDescompartilhar) &&
                          <td onClick={() => openModal(row)} className="px-3 py-2 text-xs text-gray-600 w-16">
                            <input
                              type="checkbox"
                              className="w-4 h-4 cursor-pointer"
                              checked={selectedRows.includes(row.id)}
                              onChange={() => toggleSelectedRow(row.id)}
                              onClick={(e) => e.stopPropagation()} // impede abrir modal
                            />
                          </td>
                        }
                        <td onClick={() => openModal(row)} className="px-3 py-2 text-xs text-gray-900 font-bold">{row.filialNome}</td>
                        <td onClick={() => openModal(row)} className="pl-2 py-2 pr-0 text-right text-xs text-gray-700">{row.contaReduzido}</td>
                        <td onClick={() => openModal(row)} className="pr-3 pl-1 py-2 text-xs text-gray-700">- {row.contaDescricao}</td>
                        <td onClick={() => openModal(row)} className="pl-2 py-2 pr-0 text-right text-xs text-gray-700">{row.centroCustoCodigo} </td>
                        <td onClick={() => openModal(row)} className="pr-3 pl-1 py-2 text-xs text-gray-700">- {row.centroCustoDescricao}</td>
                        <td onClick={() => openModal(row)} className="px-3 py-2 text-xs text-gray-700">{row.contaTipo}</td>
                        <td onClick={() => openModal(row)} className="text-xs text-gray-700">
                          {row.compartilhado === true &&
                            (
                              row.usuarioCompartilhadoEmail === usuario.sub ?
                                <span className="px-3 py-1 bg-gray-200 rounded-full text-gray-800 text-xs">{row.responsavelNomeUsuario}</span>
                                :
                                <span className="px-3 py-1 bg-slate-200 rounded-full text-slate-800 text-xs">Para: {row.usuarioCompartilhado}</span>

                            )
                          }
                        </td>
                        <td onClick={() => openModal(row)} className="px-3 py-2 text-xs text-right text-gray-700">
                          {row.valorTotalRealizadoAtual?.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                        <td onClick={() => openModal(row)} className="px-2 py-2 text-xs text-right text-gray-700 font-bold">
                          {row.valorTotal?.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                        <td onClick={() => openModal(row)} className="px-2 py-2 text-xs text-right text-gray-700 font-semibold">
                          {calcularPercentualRealizado(
                            row.valorTotalRealizadoAtual,
                            row.valorTotal
                          ).toFixed(2) + "%"}
                        </td>
                        <td onClick={() => openModal(row)} className="px-2 py-2 text-center">
                          {row.contaOrcada ? (
                            <span className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-xs">
                              Realizado
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-yellow-200 text-yellow-800 rounded-full text-xs">
                              Pendente
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )
                }</>)
              }
            </tbody>
          </table>
        </div>
      }

      <Pagination
        data={filteredData}
        length={changeData.length}
        currentData={setChangeData}
      />
    </div>
  );
}

function consolidarValores(data) {
  const meses = [
    "JANEIRO", "FEVEREIRO", "MARCO", "ABRIL", "MAIO", "JUNHO",
    "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"
  ];

  const consolidado = {
    atual: {},
    anterior: {},
    totalAtual: 0,
    totalAnterior: 0
  };

  meses.forEach(m => {
    consolidado.atual[m] = 0;
    consolidado.anterior[m] = 0;
  });

  data.forEach(item => {
    meses.forEach(m => {
      consolidado.atual[m] += item.valoresMensais[m] || 0;
      consolidado.anterior[m] += item.valoresMensaisAnterior[m] || 0;
    });

    consolidado.totalAtual += item.valorTotal || 0;
    consolidado.totalAnterior += item.valorTotalAnterior || 0;
  });

  return consolidado;
}

function consolidarPorConta(data) {
  const mapa = {};

  data.forEach(item => {
    const key = item.contaReduzido;
    if (!mapa[key]) {
      mapa[key] = {
        conta: key,
        descricao: item.contaDescricao,
        total: 0
      };
    }

    mapa[key].total += item.valorTotal || 0;
  });

  return Object.values(mapa);
}

function consolidarPorFilial(data) {
  const mapa = {};

  data.forEach(item => {
    const key = item.filialNome;

    if (!mapa[key]) {
      mapa[key] = {
        filialNome: key,
        total: 0,
      };
    }

    mapa[key].total += item.valorTotal || 0;
  });

  return Object.values(mapa);
}

function consolidarPorCentroCusto(data) {
  const mapa = {};

  data.forEach(item => {
    const key = item.centroCustoCodigo;

    if (!mapa[key]) {
      mapa[key] = {
        codigo: key,
        descricao: item.centroCustoDescricao,
        total: 0,
      };
    }

    mapa[key].total += item.valorTotal || 0;
  });

  return Object.values(mapa);
}

const Info = ({ color, loading, label, value }) => {
  return (
    <div className={`bg-${color}-100 border-${color}-800 px-3 py-1 rounded-full`}>
      <p className="flex text-xs text-gray-800 mb-1">
        {label}:
        <span className={`ml-1  font-bold text-${color}-700  `}>
          {loading ?
            <div className="flex items-center pt-1 pl-1">
              <Skeleton width="2rem" height="1.0rem" />
            </div>
            : value
          }
        </span>
      </p>
    </div>
  )
}
